// extracted by mini-css-extract-plugin
export default {"content":"app_content__T+cwl","search":"app_search__ZB7Lr"};